/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Richtextlinktextplaceholder4Inputs */

const en_richtextlinktextplaceholder4 = /** @type {(inputs: Richtextlinktextplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Sign up`)
};

const de_richtextlinktextplaceholder4 = /** @type {(inputs: Richtextlinktextplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Anmelden`)
};

/**
* | output |
* | --- |
* | "e.g. Sign up" |
*
* @param {Richtextlinktextplaceholder4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const richtextlinktextplaceholder4 = /** @type {((inputs?: Richtextlinktextplaceholder4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Richtextlinktextplaceholder4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_richtextlinktextplaceholder4(inputs)
	return de_richtextlinktextplaceholder4(inputs)
});
export { richtextlinktextplaceholder4 as "richTextLinkTextPlaceholder" }